export const createHeaders = (authKey?: string): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };

  if (authKey) {
    headers['auth-api-key'] = authKey;
  }

  return headers;
};
